module.exports = __webpack_public_path__ + "static/img/logo.3ce4f771.png";